import { client } from "api";
import { OrderIncompleteReason } from "models/OrderIncompleteReason";

export type UpdateReasonRequest = Pick<OrderIncompleteReason, "id" | "description" | "archived">;

export type UpdateReasonResponse = OrderIncompleteReason;

export const updateReason = ({ id, ...data }: UpdateReasonRequest) =>
  client.put<UpdateReasonResponse>(`/order-incomplete-reasons/${id}`, data).then((res) => res.data);
